module.exports = __webpack_public_path__ + "static/media/Rectangle 4152910.c726e9c5.png";